module.exports = __webpack_public_path__ + "static/media/product_03.743ae977.jpg";